<template>
  <div>
    <Modal :title="title" v-model="showModal">
      <Form :model="buildForm" ref="buildForm" class="parameter-build-form">
        <FormItem v-for="(item, index) in parameter" :key="index" :label="item.name">
          <div v-if="item.type === 'ChoiceParameterDefinition'">
            <Select v-model="buildForm[item.name]">
              <Option v-for="optionItem in item.choices" :key="optionItem" :value="optionItem">{{ optionItem }}</Option>
            </Select>
          </div>
          <div v-else>
            <Input v-model="buildForm[item.name]" />
          </div>
          <pre style="color: #999">{{ item.description }}</pre>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" :loading="building" @click="build(jenkinsId, jobName, true)">构建</Button>
        <Button @click="showModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getJenkinsJobDetail, buildJenkinsJob } from '@/api/tools/jenkins'
export default {
  name: 'build',
  data () {
    return {
      title: '参数化构建',
      showModal: false,
      jenkinsId: null,
      jobName: '',
      job: null,
      parameter: [],
      buildForm: {},
      building: false,
      callbackParams: null
    }
  },
  methods: {
    start (jenkinsId, jobName, callbackParams) {
      this.callbackParams = callbackParams
      this.jenkinsId = jenkinsId
      this.jobName = jobName
      getJenkinsJobDetail(this.jenkinsId, jobName).then(res => {
        this.job = res.data
        for (let i in this.job.property) {
          if (this.job.property[i]._class === 'hudson.model.ParametersDefinitionProperty') {
            this.parameter = this.job.property[i].parameterDefinitions
            for (let i in this.parameter) {
              this.buildForm[this.parameter[i].name] = this.parameter[i].defaultParameterValue ? this.parameter[i].defaultParameterValue.value : ''
            }
            this.title = '参数化构建[' + this.job.name + ']'
            this.showModal = true
            return
          }
        }
        this.$Modal.confirm({
          title: '确定要构建吗？',
          content: '点击确定将开始构建「' + this.job.name + '」',
          onOk: () => {
            this.build(jenkinsId, jobName)
          }
        })
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '获取Job数据失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取Job数据失败！'
          })
        }
      })
    },
    build (jenkinsId, jobName, parameterBuild = false) {
      let parameter = null
      if (parameterBuild) {
        parameter = this.buildForm
      }
      this.building = true
      buildJenkinsJob(jenkinsId, jobName, parameter).then(res => {
        this.$Notice.success({ title: '已加入构建队列！' })
        this.showModal = false
        this.building = false
        this.$emit('buildComplete', jobName, res.data, this.callbackParams)
      }).catch(res => {
        this.building = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '构建失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '构建失败！'
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  .parameter-build-form {
    .ivu-form-item-label {
      font-weight: bold;
    }
    .ivu-form-item {
      margin-bottom: unset;
    }
  }
</style>
